import React from 'react';
import MuiPhoneNumber from 'material-ui-phone-number';
import _ from 'root/libs/exaforte/react/lodash';
import CustomFormInput from './CustomFormInput';

export default class CustomPhoneNumberField extends CustomFormInput {
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {defaultCountry: true, excludeCountries: true, onlyCountries: true, preferredCountries: true})};
    }

    _onChange(value) {
        if(value == '+')
            value = null;

        this.props.onChangeText(value);
    }

    getElement() {
        let props               = this.getSupportedProps();
        props.defaultCountry    = props.defaultCountry || 'nl';

        return <MuiPhoneNumber onChange={this._onChange} {...props} InputProps={{ disableUnderline: true }} />;
    }
}